import { render, staticRenderFns } from "./ResumeAddressCmhMobile.vue?vue&type=template&id=5f3b6008&scoped=true"
import script from "./ResumeAddressCmhMobile.vue?vue&type=script&lang=ts"
export * from "./ResumeAddressCmhMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b6008",
  null
  
)

export default component.exports